/*
 * needed-with.js — <needed-with> custom element for the purchase-critical
 * accessory bundle (sections/needed-with.liquid).
 * Pure vanilla ES6, dependency-free, loaded with `defer` by the section.
 * Progressive enhancement only: without JS every partner row has its own real
 * <form action="/cart/add">; this element merely reveals the checkboxes +
 * summary row and turns them into ONE /cart/add call (items[]). Das
 * Hinzufuegen selbst — Anfrage, Auswertung, Schublade, Meldung, Ladezustand,
 * Doppelklick-Sperre — laeuft seit 26.09.2026 ueber den gemeinsamen
 * Warenkorb-Pfad window.ApCartAdd.kauf (assets/automotive.js), wie jeder
 * andere Kaufknopf. Die kleinen Geld-Helfer bleiben hier dupliziert: die aus
 * automotive.js sind privat in dessen IIFE.
 */
(function () {
  'use strict';

  // EINMAL JE SEITE (Phase D Teil 2, Paket P1 „skripte", plan.md b1 Massnahme 7): needed-with.liquid und
  // axle-partner.liquid binden die Datei je eigenstaendig ein (jede Section bleibt allein lauffaehig) — der Browser
  // fuehrt dann JEDES <script> aus. Die zweite Ausfuehrung baute bisher das ganze Modul neu auf; definiert wurde
  // dank customElements.get ohnehin nur einmal. Dieser Riegel faengt nur die Doppeldefinition ab: die erste
  // Ausfuehrung laeuft unveraendert, ein echter Fehler darin bleibt sichtbar.
  if (window.__apNeededWithGeladen) return;
  window.__apNeededWithGeladen = true;

  /**
   * Der Hauptinhalt <main id="MainContent"> als Suchwurzel — NIE das ganze
   * Dokument, wenn nach dem Kaufformular, einer Varianten-Id oder einem
   * Mengenfeld gesucht wird. `document.querySelector` trifft in
   * BAUMREIHENFOLGE, und der Warenkorb-Schubkasten steht in
   * layout/theme.liquid:557 VOR <main> (562); bei nicht leerem Korb bringt er
   * ueber den Montagecheck eigene <product-form action="/cart/add"> mit
   * (snippets/ap-cart-part.liquid:81). Gegenstueck zu hauptinhalt() in
   * automotive.js — dieselbe Regel, eigene Kopie, weil dieses Modul
   * absichtlich fuer sich steht.
   */
  const hauptinhalt = () => document.getElementById('MainContent') || document;

  /* Minor units (cents) -> die Geldschreibweise DIESES Shops.
   *
   * `symbol` ist der Rueckfall aus data-currency ("12,90 €"). Liegt am Host
   * zusaetzlich data-money-prefix / data-money-suffix, gewinnen die: Liquid
   * leitet sie aus dem echten moneyFormat des Shops ab, hier also "€" und
   * " EUR" -> "€12,90 EUR". Ohne das kippte derselbe Satz seine Schreibweise,
   * sobald das JS ihn einmal anfasst: serverseitig "€18,84 EUR", nach dem
   * ersten Klick "18,84 €" — zwei Notationen fuer dieselbe Zahl an derselben
   * Stelle. */
  function formatMoney(cents, symbol, prefix, suffix) {
    const amount = (Number(cents) || 0) / 100;
    const locale = document.documentElement.lang || 'de-DE';
    const formatted = amount.toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    if (prefix || suffix) return `${prefix || ''}${formatted}${suffix || ''}`;
    const sym = symbol || '';
    return sym ? `${formatted} ${sym}` : formatted;
  }

  /* ----------------------------------------------------------------------
   * <needed-with>
   * Markup contract (sections/needed-with.liquid + axle-partner.liquid):
   *   - rows: [data-needed-with-item] with data-variant-id, data-price (minor
   *     units), data-qty (= Bedarf JE KAUFAKT, nicht je Stueck); the current
   *     product carries [data-fixed]. [data-soldout] gibt es seit dem
   *     Bestands-Riegel (2026-08-21) nicht mehr: beide Sections rendern
   *     ausverkaufte Partner gar nicht erst als Kaufzeile — die Behandlung
   *     unten bleibt als Netz stehen, falls je eine dritte Flaeche solche
   *     Zeilen liefert. data-available steht NUR an Zeilen mit
   *     begrenztem Bestand (Bestand gefuehrt, kein Ueberverkauf) und traegt
   *     den live verfuegbaren Lagerstand; fehlt es, gilt die Zeile als
   *     unbegrenzt.
   *   - checkboxes: [data-needed-with-check]
   *   - summary: [data-needed-with-summary] (server-rendered [hidden]),
   *     live total target [data-needed-with-total],
   *     collective add button [data-needed-with-add-all],
   *     stock notice [data-needed-with-notice] (aria-live="polite"; die
   *     Textvorlagen kommen aus data-capped-text / data-capped-zero-text am
   *     Host, Platzhalter [title] und [count] wie das [days]-Muster der
   *     stockdelivery-Keys),
   *     error line [data-needed-with-error] (aria-live="polite"; fallback
   *     text comes from data-error-text on the host).
   * LIVE-REGIONEN: Ansage und Fehlerzeile werden NUR ueber ihren Text
   * gesteuert, nie ueber `hidden`. Frueher setzte der Code erst textContent
   * und nahm danach `hidden` weg — in dieser Reihenfolge entsteht die Region
   * gemeinsam mit ihrem Inhalt, und Vorleseprogramme melden nichts, weil es
   * vorher nichts zu beobachten gab. Sichtbar/unsichtbar entscheidet jetzt
   * allein `:empty` im CSS; die Zeile bleibt durchgehend im
   * Barrierefreiheitsbaum und traegt leer keine Flaeche.
   * BESTANDS-KAPPUNG: jede Zeile wird beim Summieren UND beim /cart/add.js
   * auf data-available gekappt (auch auf 0 — die Zeile bleibt dann ganz aus
   * items[]) und die Anpassung sichtbar angesagt. Vorher scheiterte der
   * GANZE Sammel-Add als 422, wenn ein Partner den Bedarf nicht hergab; der
   * 422-Pfad bleibt als Rueckfallnetz fuer Rennen zwischen Render und Kauf.
   * Mengen-Kopplung (B3): jede Zeile wird mit der LIVE gelesenen Buybox-Menge
   * multipliziert (input[name="quantity"] des Hauptprodukt-Formulars); die
   * fixe Zeile legt nur die Differenz zur bereits im Korb liegenden Menge
   * nach — nie doppelt. Beim Klick zaehlt der FRISCHE Korb (buendel(), seit
   * 26.09.2026 auch fuer die Partner: Bedarf minus schon im Korb, Bestand
   * minus schon im Korb); data-cart-quantity ist nur noch der Rueckfall.
   * On connect we add .ap-needed-with--js on the host — the CSS then shows
   * the checkboxes and hides the per-item no-JS forms.
   *
   * MENGENART JE ZEILE (Phase B, Paket Zubehoer, 29.09.2026 — Umsetzungsplan
   * Felgen-Zubehoer 2.5/4.4): data-qty-mode an der Zeile, Standard per-wheel.
   *   per-wheel  data-qty x Buybox-Menge (Felgen) — wie bisher.
   *   per-bolt   Befestiger-PACKUNG: data-bolts (Lochzahl) x Felgen = Stueck,
   *              aufgerundet auf ganze Packungen zu data-pack Stueck; gekauft
   *              werden Packungen, der Rest steht im Packungs-Hinweis
   *              ([data-needed-with-pack], Vorlagen data-pack-text[-genau] am
   *              Host). Ohne gueltige Lochzahl bzw. Packungsgroesse: 0 — nie
   *              geraten (das Liquid rendert solche Zeilen gar nicht erst).
   *   per-set    ein Artikel je Satz aus data-set (Standard 4) Felgen — NUR,
   *              wenn die Felgenmenge ganzzahlig aufgeht; sonst 0 und der
   *              Hinweis aus data-set-text (Plan 2.5: Kit je Satz).
   * refresh(): liest Zeilen und Haken neu ein (nachgeladene Kaufzeilen, z. B.
   *   der Zentrierring aus assets/ap-felgen-set.js) — ohne doppelte Listener.
   * data-anker-bedingt am Host: die feste Zeile (Ankerzeile), die Liste und die
   *   Summe stehen nur, solange es mindestens EINE sichtbare Kaufzeile gibt
   *   (Plan 2.1 Nr. 3); verborgene Zeilen ([hidden]) zaehlen nie mit.
   * data-muster an einer Zeile (Muster-Modus der Vorschau): rechnet in der
   *   Summe mit, geht aber NIE in den Warenkorb — die Ansage nennt den Grund
   *   (data-muster-text am Host).
   * -------------------------------------------------------------------- */
  class NeededWith extends HTMLElement {
    constructor() {
      super();
      this.onChange = this.onChange.bind(this);
      this.onAddAll = this.onAddAll.bind(this);
      this.onMainQtyChange = this.onMainQtyChange.bind(this);
    }

    connectedCallback() {
      this.currency = this.dataset.currency || '';
      this.items = Array.from(this.querySelectorAll('[data-needed-with-item]'));
      this.checks = Array.from(this.querySelectorAll('[data-needed-with-check]'));
      this.summary = this.querySelector('[data-needed-with-summary]');
      this.totalEl = this.querySelector('[data-needed-with-total]');
      this.addBtn = this.querySelector('[data-needed-with-add-all]');
      this.errorEl = this.querySelector('[data-needed-with-error]');
      this.noticeEl = this.querySelector('[data-needed-with-notice]');

      // MwSt.-Angabe an der Summe. Der Satz wird serverseitig fuer die
      // Ausgangsmenge gerendert, die Summe daneben schreibt renderTotal() bei
      // jedem Haken und jeder Buybox-Menge neu — ohne diesen Nachzug stuende
      // ein eingefrorener Steuerbetrag neben einer laufenden Summe. Das waere
      // schlimmer als der frueher hier stehende Satz ohne Betrag: der war bei
      // jeder Summe wahr.
      this.vatEl = this.dataset.vatTarget ? document.getElementById(this.dataset.vatTarget) : null;
      this.vatText = this.dataset.vatText || '';
      this.vatShortText = this.dataset.vatTextShort || '';
      this.moneyPrefix = this.dataset.moneyPrefix || '';
      this.moneySuffix = this.dataset.moneySuffix || '';

      // Summenlabel (P26): das servergerenderte "Gesamt" ist der Grundtext;
      // steht die Kaufbox-Menge ueber 1, setzt renderTotal() die Vorlage aus
      // data-total-label-multi ein ("Gesamt fuer je [count] Stueck"). Ohne
      // Vorlage (z. B. axle-partner.liquid) bleibt das Label unangetastet.
      this.totalLabelEl = this.querySelector('.ap-needed-with__total-label');
      this.totalLabelBase = this.totalLabelEl ? this.totalLabelEl.textContent : '';
      this.totalLabelMulti = this.dataset.totalLabelMulti || '';

      // Ankerzeile nur mit Kaufzeile (Felgenmodus mit Kaufzeilen aus dem JS):
      // Liste, feste Zeile und Summe schaltet syncAnker(), nicht das Liquid.
      this.ankerBedingt = this.hasAttribute('data-anker-bedingt');
      this.listEl = this.querySelector('.ap-needed-with__list');

      // Enhance: reveal checkboxes + summary, hide the per-item forms (CSS).
      this.classList.add('ap-needed-with--js');
      if (this.summary && !this.ankerBedingt) this.summary.removeAttribute('hidden');

      this.checks.forEach((check) => check.addEventListener('change', this.onChange));
      if (this.addBtn) this.addBtn.addEventListener('click', this.onAddAll);

      /* Buybox-Menge live mitkoppeln: Dawns Stepper feuert 'change', Tippen
       * feuert 'input'. Guard: ohne Mengenfeld (z. B. Vorlage ohne
       * quantity_selector) bleibt alles beim Fallback mainQty() == 1. */
      this.mainQtyField = this.findMainQtyField();
      if (this.mainQtyField) {
        this.mainQtyField.addEventListener('input', this.onMainQtyChange, { passive: true });
        this.mainQtyField.addEventListener('change', this.onMainQtyChange, { passive: true });
      }

      this.syncAnker();
      this.renderTotal();
    }

    /* NACHGELADENE ZEILEN (Plan 4.4): Zeilen und Haken neu einlesen — z. B. die
     * Zentrierring-Kaufzeile, die assets/ap-felgen-set.js nach der Wahl des
     * Innenmasses anlegt oder wieder entfernt. Erst ALLE alten Listener weg,
     * dann neu binden: ein Haken, der schon da war, loest sonst zweimal aus. */
    refresh() {
      if (!this.items) return;
      this.checks.forEach((check) => check.removeEventListener('change', this.onChange));
      this.items = Array.from(this.querySelectorAll('[data-needed-with-item]'));
      this.checks = Array.from(this.querySelectorAll('[data-needed-with-check]'));
      this.checks.forEach((check) => check.addEventListener('change', this.onChange));
      this.summary = this.querySelector('[data-needed-with-summary]');
      this.listEl = this.querySelector('.ap-needed-with__list');
      if (this.summary && !this.ankerBedingt) this.summary.removeAttribute('hidden');
      this.syncAnker();
      this.renderTotal();
    }

    /* ANKERZEILE NUR MIT KAUFZEILE (Plan 2.1 Nr. 3, nur mit data-anker-bedingt):
     * die feste Zeile „Dieser Artikel" und die Summe stehen genau dann, wenn
     * mindestens eine sichtbare Kaufzeile da ist; die Liste selbst, solange
     * irgendeine Zeile sichtbar ist (auch eine Luecke). Ohne JS bleibt alles,
     * wie das Liquid es rendert (verborgen). */
    syncAnker() {
      if (!this.ankerBedingt) return;
      const kauf = this.items.some((item) => !item.hasAttribute('data-fixed') && !item.hidden);
      this.items.forEach((item) => {
        if (item.hasAttribute('data-fixed') && item.hidden === kauf) item.hidden = !kauf;
      });
      if (this.summary && this.summary.hidden === kauf) this.summary.hidden = !kauf;
      if (this.listEl) {
        const sichtbar = Array.from(this.listEl.children).some((li) => !li.hidden);
        if (this.listEl.hidden === sichtbar) this.listEl.hidden = !sichtbar;
      }
    }

    disconnectedCallback() {
      this.checks.forEach((check) => check.removeEventListener('change', this.onChange));
      if (this.addBtn) this.addBtn.removeEventListener('click', this.onAddAll);
      if (this.mainQtyField) {
        this.mainQtyField.removeEventListener('input', this.onMainQtyChange);
        this.mainQtyField.removeEventListener('change', this.onMainQtyChange);
      }
    }

    // Rows that go into the bundle: the fixed current product + every checked,
    // in-stock partner. Sold-out rows never qualify — das Liquid liefert sie seit
    // dem Bestands-Riegel gar nicht mehr, der Filter bleibt als Netz.
    selectedItems() {
      return this.items.filter((item) => {
        if (item.hasAttribute('data-soldout')) return false;
        if (item.hasAttribute('data-fixed')) return true;
        // Verborgene Zeilen (z. B. der Ring-Vorschlag, den die Zentrierring-
        // Auswahl der App ersetzt) sind keine Kaufzeilen mehr.
        if (item.hidden) return false;
        const check = item.querySelector('[data-needed-with-check]');
        return !!(check && check.checked && !check.disabled);
      });
    }

    /* BEDARF EINER PARTNERZEILE fuer `felgen` Stueck des Hauptartikels —
     * die Mengenart steht an der Zeile (data-qty-mode, siehe Kopf):
     *   { menge }                      Stueck bzw. Packungen fuer den Warenkorb
     *   per-bolt: + stueck, inhalt, rest   (fuer den Packungs-Hinweis)
     *   per-set:  + satz, unganz           (unganz: Felgenmenge geht nicht auf)
     * Die feste Zeile rechnet der Aufrufer selbst (Buybox-Menge). */
    bedarf(item, felgen) {
      const n = Math.max(0, Math.floor(Number(felgen) || 0));
      const modus = item.dataset.qtyMode || 'per-wheel';
      if (modus === 'per-bolt') {
        const bolzen = parseInt(item.dataset.bolts || '', 10);
        const inhalt = parseInt(item.dataset.pack || '', 10);
        if (!(bolzen >= 3 && bolzen <= 12) || !(inhalt >= 2)) return { menge: 0, modus: modus };
        const stueck = bolzen * n;
        const packungen = Math.ceil(stueck / inhalt);
        return { menge: packungen, modus: modus, stueck: stueck, inhalt: inhalt, rest: packungen * inhalt - stueck };
      }
      if (modus === 'per-set') {
        const satz = parseInt(item.dataset.set || '4', 10) || 4;
        if (n % satz !== 0) return { menge: 0, modus: modus, satz: satz, unganz: true };
        return { menge: this.itemQty(item) * (n / satz), modus: modus, satz: satz };
      }
      return { menge: this.itemQty(item) * n, modus: 'per-wheel' };
    }

    /* „[title] gibt es nur für ganze Sätze aus [count] Felgen …" (per-set). */
    setMessage(item, satz) {
      const template = this.dataset.setText || '';
      if (!template) return '';
      return template.replace('[title]', this.itemTitle(item)).replace('[count]', String(satz));
    }

    /* Packungs-Hinweis der Befestiger-Zeilen (per-bolt): „1 × 20 Stück für 16 –
     * 4 übrig" — fuer die aktuelle Buybox-Menge, auch an nicht angehakten Zeilen
     * (die Rechnung ist eine Information, keine Auswahl). */
    renderPacks(felgen) {
      const vorlage = this.dataset.packText || '';
      const genau = this.dataset.packTextGenau || vorlage;
      if (!vorlage) return;
      this.items.forEach((item) => {
        if ((item.dataset.qtyMode || '') !== 'per-bolt') return;
        const el = item.querySelector('[data-needed-with-pack]');
        if (!el) return;
        const b = this.bedarf(item, felgen);
        if (!b.inhalt || !b.menge) return;
        const text = (b.rest > 0 ? vorlage : genau)
          .replace('[packungen]', String(b.menge))
          .replace('[inhalt]', String(b.inhalt))
          .replace('[bedarf]', String(b.stueck))
          .replace('[rest]', String(b.rest));
        if (el.textContent !== text) el.textContent = text;
      });
    }

    // The variant to add for a row. For the CURRENT product prefer the live id
    // from the main product form (it changes on variant switch); partners keep
    // their server-rendered id.
    // KNOWN LIMITATION: the fixed row's data-price stays the server-rendered
    // first-variant price, so on a MULTI-variant product with differing prices
    // the displayed total can lag a variant switch while the cart gets the live
    // variant. The pushed catalog is single-variant throughout (one product per
    // EAN), so this cannot occur today; revisit if multi-variant products appear
    // (same limitation as tyre-set-pricing's data-unit-price).
    itemVariantId(item) {
      if (item.hasAttribute('data-fixed')) {
        // ⚠ DIESER WERT WIRD GEKAUFT (onAddAll -> /cart/add.js). Dokumentweit
        // gewann das Partnerformular des Montagechecks im Warenkorb-
        // Schubkasten (steht im Layout VOR <main>), und "Zusammen in den
        // Warenkorb" legte fuer die fixe Zeile den Partner statt des
        // angezeigten Produkts ab. Der servergerenderte richtige Wert steht
        // unten in data-variant-id und wurde davon verdraengt.
        const wurzel = hauptinhalt();
        const form =
          wurzel.querySelector('product-form form[action*="/cart/add"]') ||
          wurzel.querySelector('form[action*="/cart/add"]');
        const mainId = form && form.querySelector('[name="id"]');
        if (mainId && mainId.value) return mainId.value;
      }
      return item.dataset.variantId || '';
    }

    itemQty(item) {
      return parseInt(item.dataset.qty || '1', 10) || 1;
    }

    /* Bestandsdeckel einer Zeile: data-available rendert das Liquid NUR bei
     * gefuehrtem Bestand ohne Ueberverkauf. Ohne Attribut ist die Menge
     * unbegrenzt (Infinity); ein negativer Lagerstand zaehlt als 0. */
    itemAvailable(item) {
      if (!item.hasAttribute('data-available')) return Infinity;
      const value = parseInt(item.dataset.available, 10);
      if (Number.isNaN(value)) return Infinity;
      return Math.max(0, value);
    }

    itemTitle(item) {
      const el = item.querySelector('.ap-needed-with__title');
      return el ? el.textContent.trim() : '';
    }

    /* Hinweistext fuer eine gekappte Zeile: Vorlage aus dem Liquid
     * (data-capped-text / data-capped-zero-text), Platzhalter [title] und
     * [count] — dasselbe Muster wie die [days]-Keys der Lieferzeit. */
    cappedMessage(item, capped) {
      const template =
        capped === 0 ? this.dataset.cappedZeroText || '' : this.dataset.cappedText || '';
      if (!template) return '';
      return template.replace('[title]', this.itemTitle(item)).replace('[count]', String(capped));
    }

    /* Gesammelte Bestands-Ansage im Summary-Block. aria-live="polite" —
     * eine ruhige Information, kein Alarm; nur bei echter Textaenderung
     * schreiben, damit die Vorlesestimme nicht bei jedem Tastendruck im
     * Mengenfeld erneut anhebt.
     * Kein `hidden` mehr: das schaltete die Region auf display:none und nahm
     * sie damit ganz aus dem Barrierefreiheitsbaum — die Ansage kam nie an.
     * Leerer Text blendet sie ueber `:empty` genauso lautlos wieder aus. */
    renderStockNotices(messages) {
      if (!this.noticeEl) return;
      const text = messages.filter(Boolean).join(' ');
      if (this.noticeEl.textContent !== text) this.noticeEl.textContent = text;
    }

    /* Das Hauptprodukt-Formular der Buybox (gleiches Muster wie
     * itemVariantId): bevorzugt das <product-form>-Element, sonst das erste
     * Cart-Add-Formular.
     *
     * NUR IM HAUPTINHALT (08.09.2026, gleiche Reparatur wie in
     * automotive.js): `document.querySelector` trifft in BAUMREIHENFOLGE, und
     * der Warenkorb-Schubkasten steht in layout/theme.liquid:557 VOR <main>
     * (562). Bei nicht leerem Korb rendert der Montagecheck dort eigene
     * Kaufformulare (snippets/ap-cart-part.liquid:81). Dokumentweit gewann
     * also das Partnerformular des Schubkastens, und die Buybox-Menge wurde
     * am falschen Formular abgelesen. */
    mainProductForm() {
      const wurzel = hauptinhalt();
      return (
        wurzel.querySelector('product-form form[action*="/cart/add"]') ||
        wurzel.querySelector('form[action*="/cart/add"]')
      );
    }

    /* properties[…]-Felder des Buybox-Formulars (null ohne Felder) — dieselbe Regel wie beim
     * Absenden: gesperrte Felder und abgewaehlte Kaestchen zaehlen nicht. */
    hauptEigenschaften() {
      const form = this.mainProductForm();
      if (!form) return null;
      const out = {};
      let n = 0;
      form.querySelectorAll('input[name^="properties["]').forEach((f) => {
        if (f.disabled || ((f.type === 'checkbox' || f.type === 'radio') && !f.checked)) return;
        const m = /^properties\[(.+)\]$/.exec(f.name || '');
        if (!m) return;
        out[m[1]] = f.value;
        n++;
      });
      return n ? out : null;
    }

    /* Buybox-Mengenfeld (Dawn): input[name="quantity"] liegt AUSSERHALB des
     * <form>-Tags (in <quantity-input>) und ist per form-Attribut gebunden.
     * form.id ist hier tabu: das versteckte <input name="id"> verschattet die
     * IDL-Eigenschaft (named access) — getAttribute ist verlaesslich. */
    findMainQtyField() {
      const form = this.mainProductForm();
      if (!form) return null;
      const formId = form.getAttribute('id');
      if (formId) {
        const linked = document.querySelector('input[name="quantity"][form="' + formId + '"]');
        if (linked) return linked;
      }
      return form.querySelector('input[name="quantity"]');
    }

    /* Menge je Kaufakt aus der Buybox, Fallback 1. Bewusst je Aufruf frisch
     * aufgeloest: ein Section-Rerender kann das Feld austauschen, eine
     * gecachte Referenz zeigte dann auf einen abgehaengten Knoten. */
    mainQty() {
      const field = this.findMainQtyField();
      const value = field ? parseInt(field.value, 10) : NaN;
      return value > 0 ? value : 1;
    }

    /* Bereits im Korb liegende Menge des Hauptprodukts: Dawn schreibt sie als
     * data-cart-quantity ans Mengenfeld. Fehlt Feld oder Attribut: 0.
     * NUR RUECKFALL: das Attribut stammt vom Seitenaufbau bzw. dem letzten
     * Mengenregel-Abruf und kann veraltet sein (Korb im zweiten Tab
     * geleert: "liegt bereits im Korb" bei leerem Korb, live 26.09.2026).
     * buendel() nimmt den frischen Korb und greift hierauf nur zurueck, wenn
     * /cart.js nicht antwortet. */
    mainQtyInCart() {
      const field = this.findMainQtyField();
      const value = field ? parseInt(field.getAttribute('data-cart-quantity') || '', 10) : NaN;
      return value > 0 ? value : 0;
    }

    onChange() {
      this.renderTotal();
    }

    onMainQtyChange() {
      this.renderTotal();
    }

    renderTotal() {
      // B3: die Summe zeigt das ganze Buendel in Buybox-Stueckzahl —
      // data-qty (Bedarf je Kaufakt) mal eingestellter Menge. Reicht der
      // Bestand einer Zeile nicht (data-available), rechnet die Summe mit
      // der GEKAPPTEN Menge und die Ansage darunter erklaert warum — Summe
      // und tatsaechlicher Warenkorb-Add bleiben dieselbe Zahl.
      const mainQty = this.mainQty();
      let total = 0;
      // Die Steuer wird JE ZEILE gerundet und dann summiert — jede angehakte
      // Zeile ist ein eigenes Produkt und wird beim Sammel-Add (onAddAll) eine
      // eigene Warenkorbzeile, und genau so rechnet Shopify die Rechnung.
      // Ueber `total` am Stueck gerundet stuende hier ein anderer Cent als im
      // Warenkorbfuss derselben Bestellung.
      let vat = 0;
      const notices = [];
      const factors = new Map();
      this.selectedItems().forEach((item) => {
        // Mengenart der Zeile (bedarf); die feste Zeile ist die Buybox-Menge.
        const b = item.hasAttribute('data-fixed') ? { menge: this.itemQty(item) * mainQty } : this.bedarf(item, mainQty);
        const desired = b.menge;
        const capped = Math.min(desired, this.itemAvailable(item));
        const line = (parseInt(item.dataset.price || '0', 10) || 0) * capped;
        total += line;
        if (line > 0) vat += line - Math.round(line / 1.19);
        if (b.unganz) notices.push(this.setMessage(item, b.satz));
        else if (capped < desired) notices.push(this.cappedMessage(item, capped));
        factors.set(item, capped);
      });
      if (this.totalEl) this.totalEl.textContent = formatMoney(total, this.currency, this.moneyPrefix, this.moneySuffix);
      this.renderVat(vat, total);
      this.renderStockNotices(notices);
      this.renderFactors(factors, mainQty);
      this.renderPacks(mainQty);
    }

    /* SICHTBARER FAKTOR (P26). Die Summe ist absichtlich mit der Kaufbox-Menge
     * multipliziert (B3) — die Zeilen zeigten aber nur Stueckpreise: 34,99 € +
     * 22,99 € ergaben "Gesamt 231,92 €", und das las sich wie ein Rechenfehler
     * oder versteckte Kosten. Jetzt steht vor jedem Preis der TATSAECHLICHE
     * Faktor ("4 × €34,99") — bestandsgekappt, also genau die Menge, die der
     * Sammel-Add ablegt; eine auf 0 gekappte Zeile zeigt ehrlich "0 ×". Nicht
     * angehakte Zeilen zeigen keinen Faktor, sie gehen nicht in die Summe.
     * Steht ueberall 1, bleibt alles wie bisher (ein "1 ×" waere nur Rauschen).
     *
     * Das Faktor-Element wird bei Bedarf angelegt: so bekommt auch jeder andere
     * Host dieses Elements (axle-partner.liquid) den Faktor, ohne eigenes
     * Markup. Der Stueckpreis mit seiner Steuerangabe bleibt unveraendert
     * stehen (PAngV). */
    renderFactors(factors, mainQty) {
      let showFactors = false;
      factors.forEach((qty) => {
        if (qty !== 1) showFactors = true;
      });
      this.items.forEach((item) => {
        const price = item.querySelector('.ap-needed-with__price');
        if (!price) return;
        let factorEl = price.querySelector('.ap-needed-with__factor');
        const text = showFactors && factors.has(item) ? `${factors.get(item)} × ` : '';
        if (!factorEl) {
          if (!text) return;
          factorEl = document.createElement('span');
          factorEl.className = 'ap-needed-with__factor';
          factorEl.setAttribute('data-needed-with-factor', '');
          price.insertBefore(factorEl, price.firstChild);
        }
        if (factorEl.textContent !== text) factorEl.textContent = text;
      });

      if (this.totalLabelEl && this.totalLabelMulti) {
        const label =
          mainQty > 1 ? this.totalLabelMulti.replace('[count]', String(mainQty)) : this.totalLabelBase;
        if (this.totalLabelEl.textContent !== label) this.totalLabelEl.textContent = label;
      }
    }

    /* Zieht den MwSt.-Satz auf GENAU die Zahl nach, die eben in der Summe
     * gelandet ist (bestandsgekappt). `vat` ist bereits JE ZEILE gerundet und
     * summiert — siehe renderTotal; diese Methode rechnet nichts mehr, sie
     * formatiert nur.
     *
     * Die Rundung dort (`line - Math.round(line / 1.19)`) ist NICHT nur
     * ungefaehr, sondern bitgleich mit der Ganzzahlformel aus
     * snippets/ap-mwst-hinweis.liquid (floor((200*brutto + 119) / 238)): ueber
     * alle Betraege von 0 bis 5.000.000 Cent nachgerechnet, null Abweichung.
     * Das gilt, weil 100*t/119 bei ungeradem Nenner nie exakt auf ,5 faellt —
     * die Rundungsrichtung ist also nie strittig, und der Fliesskommafehler
     * (~1e-9) bleibt weit unter dem kleinsten Abstand zur Kippkante
     * (1/238 ~ 0,0042). Kein floor, kein toFixed-Umweg.
     *
     * Faellt die Summe auf 0 (alle Zeilen auf Bestand 0 gekappt), wird der
     * Klammerwert ENTFERNT statt stehengelassen: ein Steuerbetrag neben einer
     * 0,00-Summe gehoert sichtbar nicht dorthin. Uebrig bleibt der Kurzsatz,
     * der bei jeder Summe wahr ist. */
    renderVat(vat, total) {
      if (!this.vatEl || !this.vatText) return;
      if (total <= 0 || vat <= 0) {
        if (this.vatShortText) this.vatEl.textContent = this.vatShortText;
        return;
      }
      this.vatEl.textContent = this.vatText.replace('[amount]', formatMoney(vat, this.currency, this.moneyPrefix, this.moneySuffix));
    }

    onAddAll(event) {
      if (typeof fetch !== 'function') return; // No fetch: nothing to enhance.
      event.preventDefault();
      this.clearError();

      /* KLICK BIS ZUSTAND ueber den EINEN Warenkorb-Pfad des Themes
       * (window.ApCartAdd.kauf, assets/automotive.js): Ladezustand,
       * Doppelklick-Sperre, Schublade bei Erfolg, Teilmenge und vollem Korb,
       * Meldung in der Fehlerzeile nur bei echtem Fehler.
       *
       * LEERE LISTE IST KEIN "nichts tun" (live 26.09.2026): lag das
       * Hauptprodukt schon in Buybox-Menge im Korb und war kein Partner
       * angehakt, endete der Klick hier mit `return` — keine Anfrage, kein
       * Spinner, keine Meldung. Jetzt oeffnet der gemeinsame Pfad die
       * Schublade mit "Die gewaehlte Menge liegt bereits in Ihrem Warenkorb".
       *
       * Die Positionen rechnet buendel() erst, wenn der FRISCHE Korb da ist
       * (die anfrage ist eine Funktion) — siehe dort. */
      const cartAdd = window.ApCartAdd;
      if (!cartAdd || typeof cartAdd.kauf !== 'function') {
        // automotive.js fehlt: sichtbar scheitern statt stumm.
        this.showError('');
        return;
      }
      this.kaufAnsage = '';
      cartAdd.kauf({
        knopf: this.addBtn,
        host: this,
        anfrage: (korb) => this.buendel(korb),
        quelle: 'needed-with',
        aktiv: this.addBtn,
        // Der eigene, uebersetzte Fehlertext des Blocks (ap.neededwith.add_error)
        // bleibt; Hinweise zu Teilmenge und vollem Korb kommen aus ap.kauf.
        texte: this.dataset.errorText ? { fehler: this.dataset.errorText } : null,
        // Gekappte Zeilen stehen nach dem Klick mit in der Schublade — die
        // Ansage unter dem Knopf verdeckt sie dann.
        hinweis: () => this.kaufAnsage,
        meldung: (text) => (text ? this.showError(text) : this.clearError()),
      });
    }

    /* Die Positionen fuer EINEN Aufruf, gerechnet gegen den frischen Korb
     * (korb.menge(id): Stueck im Korb, null = unbekannt).
     *
     *   - Hauptprodukt (fixe Zeile): DOPPEL-ADD-GUARD (B3) — nur die
     *     Differenz zwischen Buybox-Menge und Korb, gedeckelt auf den freien
     *     Bestand (data-available ist der GESAMTbestand, der Korb zehrt ihn
     *     mit auf). Vorher: Buybox(2) + Buendel machten 3 Reifen zu 1 Schlauch.
     *   - Partner: Bedarf data-qty x max(Buybox-Menge, Hauptprodukt NACH
     *     diesem Klick im Korb), MINUS was vom Partner schon drin liegt,
     *     gedeckelt auf seinen freien Bestand (Bestand minus Korb).
     *     Vorher zaehlte beim Partner weder der Korb noch sein Bestand im
     *     Korb: der zweite Klick legte die Zentrierringe noch einmal ab (3
     *     Ringe zu 2 Felgen), und ein Ring, dessen ganzer Bestand schon im
     *     Korb lag, liess Shopify den GANZEN Aufruf ablehnen — die Felge
     *     fehlte, die Schublade ging trotzdem auf (live 26.09.2026).
     *   - Eine Zeile mit 0 bleibt ganz weg (kein 0er-Posten); fehlt dabei
     *     Bedarf, sagt die Ansage warum (kaufAnsage -> Schubladen-Hinweis).
     * Liefert Positionen mit titel — den nennt die Meldung, wenn Shopify eine
     * Zeile doch ablehnt; an Shopify geht er nicht. */
    buendel(korb) {
      const imKorb = (id, rueckfall) => {
        const n = korb && typeof korb.menge === 'function' ? korb.menge(id) : null;
        return typeof n === 'number' && n >= 0 ? n : rueckfall;
      };
      const texte =
        window.ApCartAdd && typeof window.ApCartAdd.texte === 'function' ? window.ApCartAdd.texte() : {};
      const fill = (vorlage, titel, n) =>
        String(vorlage || '')
          .split('[n]')
          .join(String(n))
          .split('[titel]')
          .join(titel);

      const mainQty = this.mainQty();
      const auswahl = this.selectedItems();
      const fest = auswahl.find((item) => item.hasAttribute('data-fixed')) || null;

      let hauptImKorb = 0;
      let hauptJetzt = 0;
      if (fest) {
        hauptImKorb = imKorb(this.itemVariantId(fest), this.mainQtyInCart());
        hauptJetzt = Math.max(0, mainQty - hauptImKorb);
        const bestand = this.itemAvailable(fest);
        if (bestand !== Infinity) hauptJetzt = Math.min(hauptJetzt, Math.max(0, bestand - hauptImKorb));
      }
      // Bedarfsbasis der Partner: mindestens die Buybox-Menge (so rechnet auch
      // die Summe im Block, renderTotal — Summe und Ablage bleiben dieselbe
      // Zahl), und mindestens so viel, wie vom Hauptprodukt nach dem Klick im
      // Korb liegt. Das Zweite zaehlt beim zweiten Klick: das Mengenfeld ist
      // dann auf den freien Rest geklemmt (1), im Korb liegen aber schon 2
      // Felgen — deren 2 Ringe liegen auch schon drin, also nichts nachlegen.
      // Ohne fixe Zeile (fremder Host) bleibt es beim Buybox-Faktor.
      const basis = fest ? Math.max(mainQty, hauptImKorb + hauptJetzt) : mainQty;

      const saetze = [];
      const items = [];
      let musterDabei = false;
      auswahl.forEach((item) => {
        // MUSTER (nur Vorschau): Beispielzeilen tragen erfundene Varianten-Ids —
        // sie rechnen in der Summe mit, gehen aber NIE an Shopify.
        if (item !== fest && item.hasAttribute('data-muster')) {
          musterDabei = true;
          return;
        }
        const variantId = this.itemVariantId(item);
        if (!variantId) return;
        let quantity = hauptJetzt;
        if (item !== fest) {
          const schon = imKorb(variantId, 0);
          const b = this.bedarf(item, basis);
          const fehlt = Math.max(0, b.menge - schon);
          const bestand = this.itemAvailable(item);
          const frei = bestand === Infinity ? Infinity : Math.max(0, bestand - schon);
          quantity = Math.min(fehlt, frei);
          if (b.unganz) saetze.push(this.setMessage(item, b.satz));
          else if (quantity < fehlt) {
            const titel = this.itemTitle(item);
            if (schon > 0 && quantity === 0 && texte.zeileVoll) saetze.push(fill(texte.zeileVoll, titel, schon));
            else if (schon > 0 && texte.zeileTeil) saetze.push(fill(texte.zeileTeil, titel, schon + quantity));
            else saetze.push(this.cappedMessage(item, quantity));
          }
        }
        if (quantity === 0) return;
        const zeile = { id: Number(variantId) || variantId, quantity: quantity, titel: this.itemTitle(item) };
        // Die Hauptposition traegt die Positions-Eigenschaften der Buybox mit (Fahrzeugwahl Felgen:
        // _ap_fahrzeug_id, _ap_passung, _ap_fahrzeug bzw. „Vorabprüfung" — THEME-SPEC 8 „in allen
        // Hinzufuegen-Wegen"); Partner nie.
        if (item === fest) {
          const eigenschaften = this.hauptEigenschaften();
          if (eigenschaften) zeile.properties = eigenschaften;
        }
        items.push(zeile);
      });
      if (musterDabei) saetze.push(this.dataset.musterText || '');
      this.kaufAnsage = saetze.filter(Boolean).join(' ');
      return items;
    }

    /* Fehlerzeile im Summary-Block (aria-live="polite"): Klartext statt
     * stillem Scheitern. Der Fallback-Text kommt uebersetzt aus dem Liquid
     * (data-error-text); der String hier ist nur die letzte Reserve.
     * Auch hier gilt: nur der Text wird angefasst. Ein `hidden` haette die
     * Region erst im Fehlerfall entstehen lassen — zu spaet, um angesagt zu
     * werden. */
    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent =
        message || this.dataset.errorText || 'Das hat leider nicht geklappt. Bitte erneut versuchen.';
    }

    clearError() {
      if (!this.errorEl) return;
      this.errorEl.textContent = '';
    }

  }

  function defineComponent() {
    if (!('customElements' in window)) return;
    if (!customElements.get('needed-with')) {
      customElements.define('needed-with', NeededWith);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', defineComponent, { once: true });
  } else {
    defineComponent();
  }
})();
